import fileDownload from "js-file-download";

import { axiosInstance } from "src/1/axios";
import { FORM_HEADER_ENCODED, get, map, post } from "src/utils/axios";

import { MaterialGroups } from "_models/material-group.model";

import { MATERIAL_GROUP } from "./_constants";

export const getForRole = async () =>
  await map(({ data }) => data).get(MATERIAL_GROUP.getForRole);

export const getAll = async (params) =>
  await map(({ data }) => data.map((d) => new MaterialGroups(d))).get(
    MATERIAL_GROUP.getAll,
    { params }
  );

export const getByCode = async (code) =>
  await map().get(`${MATERIAL_GROUP.getByCode}/${code}`);

export const create = async (values) => {
  const body = { ...values, active: Number(values?.active) };

  return await axiosInstance.post(MATERIAL_GROUP.create, body);
};

export const update = async (values) => {
  const body = { ...values, active: Number(values?.active) };

  return await post(MATERIAL_GROUP.update, body);
};

export const remove = async (codes) => {
  const params = new URLSearchParams();
  params.append("listCode", codes.join(","));
  return await post(MATERIAL_GROUP.delete, params, FORM_HEADER_ENCODED);
};

export const exportExcel = async (params) => {
  get(MATERIAL_GROUP.exportExcel, {
    params,
    responseType: "blob",
    headers: FORM_HEADER_ENCODED,
  }).then((res) => {
    return fileDownload(res.data, "report.xlsx");
  });
};
